import queryString from "query-string"
import {Dropdown, Icon, Menu} from "semantic-ui-react"
import {FormattedMessage} from "react-intl"
import React, {useState} from "react"
import {EventHandlers} from "./top-bar"
import {useNavigate, useLocation} from "react-router"
import {ViewMenu} from "./view-menu"


type ChartMenusProps = {
    loading: boolean
    eventHandlers: EventHandlers
}

export function ChartMenu({ loading, eventHandlers } : ChartMenusProps) {
    const navigate = useNavigate()
    const location = useLocation()
    const [currentView, setCurrentView] = useState("hourglass")

    const changeView = (view: string) => {
        setCurrentView(view)
        const search = queryString.parse(location.search)
        if (search.view !== view) {
            search.view = view
            location.search = queryString.stringify(search)
            navigate(location)
        }
    }

    /**
     * @deprecated
     */
    const viewMenu = <Dropdown className="hidden item" trigger={
        <div>
            {currentView === "hourglass"
                ? <><Icon name="hourglass"/><FormattedMessage id="menu.hourglass"/></>
                : <><Icon name="users"/><FormattedMessage id="menu.relatives"/></>
            }
        </div>
    }><Dropdown.Menu><ViewMenu currentView={currentView} changeView={changeView}/></Dropdown.Menu>
    </Dropdown>

    return (
        <>
            <Menu className="chart-menu linkblue">
                {/* HOME */}
                <Menu.Item key="home" onClick={eventHandlers.onHome}>
                    <Icon name="home"/><FormattedMessage id="menu.home"/>
                </Menu.Item>
                {/* DOWNLOAD */}
                <Dropdown className="animated-dropdown item" trigger={
                    <div>
                        <Icon name="download"/><FormattedMessage id="menu.download"/>
                    </div>
                }>
                    <Dropdown.Menu>
                        {/* DOWNLOAD PNG */}
                        <Dropdown.Item key="png" onClick={eventHandlers.onDownloadPng}>
                            <Icon name="image"/><FormattedMessage id="menu.download.png"/>
                        </Dropdown.Item>
                        {/* DOWNLOAD SVG */}
                        <Dropdown.Item key="svg" onClick={eventHandlers.onDownloadSvg}>
                            <Icon name="image outline"/><FormattedMessage id="menu.download.svg"/>
                        </Dropdown.Item>
                        <Dropdown.Divider/>
                        {/* DOWNLOAD GEDCOM */}
                        <Dropdown.Item key="ged" onClick={eventHandlers.onDownloadGedcom}>
                            <Icon name="code"/><FormattedMessage id="menu.download.gedcom"/>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                {/* VIEW (deprecated) */}
                {viewMenu}
                {/* RESET VIEW */}
                <Menu.Item key="reset" style={{paddingLeft: "0.5em"}} onClick={eventHandlers.onResetView}>
                    <Icon name="target"/><FormattedMessage id="menu.view.reset"/>
                </Menu.Item>
                {/* EDIT */}
                <Menu.Item key="edit" className="convert-button" disabled={loading} onClick={eventHandlers.onEditGedcom}>
                    {loading ? <Icon name="spinner" loading/> : <Icon name="edit"/>}
                    <FormattedMessage id="menu.edit.gedcom"/>
                </Menu.Item>
            </Menu>
        </>
    )
}